/**
 * Module-level storage for the DOM element that last triggered a compare
 * toggle. CompareButton sets this when the user uses the skip link to navigate
 * to the compare bar, and CompareBar reads it to return focus when the bar
 * is dismissed.
 *
 * A plain module variable is used instead of Redux because DOM element
 * references are non-serializable.
 */
let triggerElement = null;

export const setCompareTriggerElement = (element) => {
	triggerElement = element;
};

export const getCompareTriggerElement = () => triggerElement;

export const clearCompareTriggerElement = () => {
	triggerElement = null;
};
